export const MAX_NEGOCIO_REMINDERS = 4;

import { DEFAULT_REMINDER_MESSAGE } from "./helpers";

export const DEFAULT_PAYMENT_REMINDER_MESSAGE = `Hola {{nombre_cliente}} 👋

Tienes pendiente el pago de estos servicios:

{{servicios}}

💰 Total pendiente: *{{total_pendiente}}*

Si ya pagaste, envíanos el comprobante por este chat para verificarlo. ¡Gracias!`;

export const DEFAULT_ACCOUNT_REMINDER_MESSAGE = `Hola {{nombre_proveedor}} 👋

Estas cuentas están por vencer. ¿Puedes renovarlas?

{{cuentas}}`;

const reminderDefault = (type) =>
  type === "pending_payment"
    ? DEFAULT_PAYMENT_REMINDER_MESSAGE
    : type === "accounts"
      ? DEFAULT_ACCOUNT_REMINDER_MESSAGE
      : DEFAULT_REMINDER_MESSAGE;

export function changeReminderType(form, reminderType) {
  const previousDefault = reminderDefault(form.reminderType);
  return {
    ...form,
    reminderType,
    daysOffset: reminderType === "pending_payment" ? 0 : 3,
    includePointsMessage: false,
    message: !form.message?.trim() || form.message === previousDefault
      ? reminderDefault(reminderType)
      : form.message,
  };
}

export const reminderVariables = (payment) => [
  { key: "nombre_cliente", label: "Cliente", sample: "Laura Barrios", color: "#00695c" },
  { key: "telefono", label: "Teléfono", sample: "573001234567", color: "#546e7a" },
  { key: "codigo", label: "Código cliente", sample: "C1024", color: "#546e7a" },
  { key: "servicios", label: payment ? "Servicios pendientes de pago" : "Servicios", sample: payment ? "• Spotify · Premium\n   Pago pendiente #123: $12.000 COP" : undefined, color: "#ad1457" },
  ...(payment ? [
    { key: "total_pendiente", label: "Total pendiente", sample: "$12.000 COP", color: "#4527a0" },
    { key: "pagos_pendientes", label: "Pagos pendientes", sample: "123", color: "#546e7a" },
  ] : []),
];
